import { Typography } from '@mui/material'
import React from 'react'

export const PageSubTitle: React.FC<{ children: React.ReactNode | React.ReactNode[] }> = ({ children }) => {
  return <Typography variant="subtitle2">{children}</Typography>
}
